import {
    CreateWidgetAssetResult,
    CreateWidgetVariables,
    ZWidgetLibraryAssetDto,
    UpdateWidgetAssetResult,
    IUpdateWidgetVariables,
    CreateImageAssetResult,
    ICreateImageVariables,
    ZImageLibraryAssetDto
} from '@studio/domain/creativeset';
import { toGraphqlDto } from '@studio/utils/zod';
import { gql } from 'apollo-angular';

export const CREATE_WIDGET_ASSET = gql<CreateWidgetAssetResult, CreateWidgetVariables>`
    mutation CreateWidgetAssetMutation($widget: WidgetAssetInputType!, $brandId: String!) {
        createWidgetAsset(
            widget: $widget,
            brandId: $brandId
        )
        { ${toGraphqlDto(ZWidgetLibraryAssetDto)} }
    }`;

export const UPDATE_WIDGET_ASSET = gql<UpdateWidgetAssetResult, IUpdateWidgetVariables>`
    mutation UpdateWidgetMutation($id: String!, $widget: WidgetAssetInputType!, $brandId: String!, $accountSlug: String!) {
        updateWidgetAsset(
            id: $id,
            widget: $widget,
            brandId: $brandId,
            accountSlug: $accountSlug
        )
        { ${toGraphqlDto(ZWidgetLibraryAssetDto)} }
    }`;

export const CREATE_IMAGE_ASSET = gql<CreateImageAssetResult, ICreateImageVariables>`
    mutation CreateImageAssetMutation($image: ImageAssetInput!) {
        createImageAsset(
            image: $image
        )
        { ${toGraphqlDto(ZImageLibraryAssetDto)} }
    }`;
